import User from './User';
import Profile from './Profile';
import Settings from './Settings';
import ModelAbstract from './ModelAbstract';
import Post from './Post';
import Poll from './Poll';
import Address from './Address';
import Relationship from './Relationship';


// Figure models
import Figure from './Figure';
import FigureCollection from './FigureCollection';
import FigureImage from './FigureImage';
import FigureDraft from './FigureDraft';
import Company from './Company';
import CompanyFigure from './CompanyFigure';

const MODELS = {
    User,
    Profile,
    Settings,
    ModelAbstract,
    Post,
    Poll,
    Address,
    Relationship,
    Figure,
    FigureCollection,
    FigureImage,
    FigureDraft,
    Company,
    CompanyFigure
}; 

export default MODELS;

// Named exports for individual models
export {
    User,
    Profile,
    Settings,
    ModelAbstract,
    Post,
    Poll,
    Address,
    Relationship,
    Figure,
    FigureCollection,
    FigureImage,
    FigureDraft,
    Company,
    CompanyFigure
};